import React from "react";

// Pair Icons
import btcIcon from "@assets/images/futures_pairs/btcusdt.svg";
import ethIcon from "@assets/images/futures_pairs/ethusdt.svg";
import bnbIcon from "@assets/images/futures_pairs/bnbusdt.svg";
import xrpIcon from "@assets/images/futures_pairs/xrpusdt.svg";
import adaIcon from "@assets/images/futures_pairs/adausdt.svg";
import ltcIcon from "@assets/images/futures_pairs/ltcusdt.svg";
import trxIcon from "@assets/images/futures_pairs/trxusdt.svg";

import "./OpenPositionsTable.sass";

// --- MOCK DATA ---
const mockPositions = [
  {
    symbol: "BTC",
    pair: "BTC/USDT",
    type: "Long",
    leverage: "5x",
    size: "0.095 BTC",
    entryPrice: "41,200.00",
    markPrice: "42,480.50",
    marginValue: "$7,820.40",
    marginType: "Cross",
    pnlValue: "+$121.65",
    pnlPercent: "+7.78%",
    icon: btcIcon,
  },
  {
    symbol: "ETH",
    pair: "ETH/USDT",
    type: "Long",
    leverage: "10x",
    size: "2.85 ETH",
    entryPrice: "2,450.00",
    markPrice: "2,610.80",
    marginValue: "$7,820.40",
    marginType: "Isolated",
    pnlValue: "+$458.28",
    pnlPercent: "+23.14%",
    icon: ethIcon,
  },
  {
    symbol: "TRX",
    pair: "Tron/USDT",
    type: "Long",
    leverage: "5x",
    size: "6,500 TRX",
    entryPrice: "0.1215",
    markPrice: "0.1282",
    marginValue: "$7,820.40",
    marginType: "Cross",
    pnlValue: "+$43.55",
    pnlPercent: "+10.35%",
    icon: trxIcon,
  },
  {
    symbol: "BNB",
    pair: "BNB/USDT",
    type: "Short",
    leverage: "5x",
    size: "-1.35 BNB",
    entryPrice: "610.00",
    markPrice: "585.40",
    marginValue: "$7,820.40",
    marginType: "Cross",
    pnlValue: "+$33.21",
    pnlPercent: "+2.15%",
    icon: bnbIcon,
  },
  {
    symbol: "LTC",
    pair: "LTC/USDT",
    type: "Long",
    leverage: "15x",
    size: "14.5 LTC",
    entryPrice: "68.40",
    markPrice: "72.90",
    marginValue: "$7,820.40",
    marginType: "Cross",
    pnlValue: "+$65.25",
    pnlPercent: "+20.35%",
    icon: ltcIcon,
  },
  {
    symbol: "XRP",
    pair: "XRP/USDT",
    type: "Short",
    leverage: "5x",
    size: "-8,200 XRP",
    entryPrice: "0.5450",
    markPrice: "0.5310",
    marginValue: "$7,820.40",
    marginType: "Isolated",
    pnlValue: "+$114.80",
    pnlPercent: "+22.48%",
    icon: xrpIcon,
  },
  {
    symbol: "ADA",
    pair: "ADA/USDT",
    type: "Long",
    leverage: "5x",
    size: "4,200 ADA",
    entryPrice: "0.3420",
    markPrice: "0.3695",
    marginValue: "$7,820.40",
    marginType: "Cross",
    pnlValue: "+$115.50",
    pnlPercent: "+19.90%",
    icon: adaIcon,
  },
];

export const OpenPositionsTable = () => {
  return (
    <div className="open-positions-table">
      <div className="open-positions-table__content-wrapper">
        <table className="open-positions-table__table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Size</th>
              <th>Entry Price</th>
              <th>Mark Price</th>
              <th>Margin</th>
              <th>PNL (ROE)</th>
            </tr>
          </thead>
          <tbody>
            {mockPositions.map((pos, i) => {
              const isLong = pos.type === "Long";

              return (
                <tr key={i}>
                  {/* SYMBOL COLUMN */}
                  <td>
                    <div className="open-positions-table__symbol-cell">
                      <img
                        src={pos.icon}
                        alt={pos.symbol}
                        className="open-positions-table__icon"
                      />

                      <div className="open-positions-table__symbol-info">
                        <span className="open-positions-table__pair">
                          {pos.pair}
                        </span>
                        <span
                          className={`open-positions-table__badge ${
                            isLong
                              ? "open-positions-table__badge--long"
                              : "open-positions-table__badge--short"
                          }`}
                        >
                          {pos.type} {pos.leverage}
                        </span>
                      </div>
                    </div>
                  </td>

                  {/* SIZE COLUMN */}
                  <td
                    className={
                      isLong
                        ? "open-positions-table__text--green"
                        : "open-positions-table__text--red"
                    }
                  >
                    {pos.size}
                  </td>

                  {/* ENTRY / MARK PRICE COLUMNS */}
                  <td>{pos.entryPrice}</td>
                  <td>{pos.markPrice}</td>

                  {/* MARGIN COLUMN (Multi-line) */}
                  <td>
                    <div className="open-positions-table__multi-line">
                      <span>{pos.marginValue}</span>
                      <span className="open-positions-table__text--gray">
                        ({pos.marginType})
                      </span>
                    </div>
                  </td>

                  {/* PNL COLUMN (Multi-line) */}
                  <td>
                    <div className="open-positions-table__multi-line">
                      <span
                        className={
                          isLong
                            ? "open-positions-table__text--green"
                            : "open-positions-table__text--red"
                        }
                      >
                        {pos.pnlValue}
                      </span>
                      <span className="open-positions-table__text--gray">
                        ({pos.pnlPercent})
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
